import { Flex } from 'antd'
import Image from '@/components/image'
import Icon, { IconName } from '@/components/icon'
import imageNature from '@/assets/img/about-us/nature.png'
import Styles from './style.module.scss'

interface DataItemProps {
  icon: IconName
  title: string
}

const TITLE = 'About Carus EPC'
const DESCRIPTIONS = [
  'We are the architects of comprehensive, end- to-end energy solutions, embracing every facet of solar photovoltaic(PV) and BESS technology from conceptualization to commissioning.',
  'Our expertise encompasses modeling and designing, hardware integration, supply chain management, environmental engineering, energy management software, control and monitoring systems, cloud computation, and data collection.',
]
const data: DataItemProps[] = [
  {
    icon: 'circularEnergy',
    title: 'Energy',
  },
  {
    icon: 'power',
    title: 'Power and Sustainability',
  },
  {
    icon: 'cleanEnergy',
    title: 'Conservation and clean energy',
  },
]

export default function Epc() {
  return (
    <Flex justify='space-between' className={Styles.epc}>
      <div className={Styles.left}>
        <h2>{TITLE}</h2>
        <div className={Styles.descriptions}>
          {DESCRIPTIONS.map((item, index) => (
            <div key={index} className={Styles.descriptionItem}>
              {item}
            </div>
          ))}
        </div>
        <Flex justify='space-between' className={Styles.content}>
          {data.map((item, index) => (
            <Flex vertical align='center' key={index} className={Styles.item}>
              <Icon name={item.icon} className={Styles.icon} />
              <div className={Styles.title}>{item.title}</div>
            </Flex>
          ))}
        </Flex>
      </div>
      <Image src={imageNature} alt='nature' className={Styles.image} />
    </Flex>
  )
}
